import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Button, TabLayout } from "../../kaya";
import PersonalDetails from "../PersonalDetails";
import BusinessDetails from "../BusinessDetails";
import ContactUs from "../ContactUs";
import PopUp from "../popUp";
import { ICONS } from "../../constants/icons.constants";
import userStore from "../../zustand/user.store";

import styles from "./ProfilePage.module.scss";
import PlanDetail from "../PlanDetail";
import { logoutAction } from "../../actions/user.actions";
import { routesConstants } from "../../constants";

const Page = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { flushUserData, setAuthentication } = userStore((state) => ({
    user: state.user,
    flushUserData: state.flushUserData,
    setAuthentication: state.setAuthentication,
  }));

  const initialTab = useMemo(() => {
    const openTab = location?.state?.openTab;
    // Tabs order: 0 Personal, 1 Business, 2 Plans, 3 Contact
    if (openTab === "plans") return 2;
    return 0;
  }, [location]);

  const handleLogout = async () => {
    setVisible((prevState) => !prevState);
    // const res = await logoutAction();
    // if (res?.success) {
    //   navigate(routesConstants.ROUTES.LOGIN);
    // }
  };

  const handleProfileLogout = () => {
    localStorage.clear();
    flushUserData();
    setAuthentication({
      isAuthenticated: false,
      isPhoneVerified: false,
      isBusinessVerified: false,
      isPrimium: false,
    });
  };

  return (
    <div className={styles.profilePage}>
      <div className={styles.header}>
        <h1 className={styles.heading}>Profile Details</h1>
        <div className={styles.logoutBtn}>
          <Button
            type="Secondary"
            className={styles.btn}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      </div>

      <PopUp
        iconType={ICONS.LOGOUT}
        title="Are you sure you want to logout ?"
        btnPlaceholder="Logout"
        isOpen={visible}
        setIsOpen={setVisible}
        onSuccess={handleProfileLogout}
      />
      <div className={styles.tabContainer}>
        <div className={styles.tabbar}>
          <TabLayout
            key={`profile-tabs-${initialTab}`}
            tabHeaderClassName={styles.tabHeader}
            tabs={[
              {
                label: "Personal Details",
              },
              {
                label: "Business Information",
              },
              {
                label: "Plans",
              },
              {
                label: "Contact Support",
              },
            ]}
            contanierClassName={styles.tabBox}
            tabClassName={styles.tab}
            tabsContent={[
              <PersonalDetails />,
              <BusinessDetails />,
              <PlanDetail />,
              <ContactUs />,
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Page;
